
import autoTable from 'jspdf-autotable';
import { PAGE_LAYOUT, TEXT_STYLES, IMAGES } from '../Constants';

export const PDFGuidelines = {
  add: function (doc) {
    let currentY = PAGE_LAYOUT.MARGIN;
    const footerY = PAGE_LAYOUT.HEIGHT - PAGE_LAYOUT.FOOTER_HEIGHT;
    const imageReservedHeight = 60;

    // -- Page Heading with Orange Bar --
    doc.setFillColor(255, 100, 20); // Orange
    doc.roundedRect(
      PAGE_LAYOUT.MARGIN,
      currentY,
      PAGE_LAYOUT.WIDTH - 2 * PAGE_LAYOUT.MARGIN,
      12,
      3, 3, 'F'
    );
    doc.setTextColor(255, 255, 255); // White text
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(TEXT_STYLES.SIZES.TITLE + 2);
    doc.text('DIETARY NOTES', PAGE_LAYOUT.WIDTH / 2, currentY + 8, { align: 'center' });
    currentY += 16;

    // --- Tables ---
    const guidelines = [
      ["1. Include small and frequent meals to improve metabolism and satiety."],
      ["2. Follow exact portion sizes to avoid exceeding calorie budget."],
      ["3. Include fibre and protein-rich foods like fruits, dairy, pulses, nuts, seeds."],
      ["4. Avoid excessive oil consumption (500 ml per person/month)."],
      ["5. Consume tea/coffee 30 min before/after meals to prevent nutrient interference."],
      ["6. Avoid processed, refined, deep-fried, and bakery food items like biscuits, chips, pastries, etc."]
    ];

    const points = [
      ["1. Do not skip meals."],
      ["2. Do not overeat."],
      ["3. Stick to meal timings and portion sizes."],
      ["4. Hydrate yourself properly."],
      ["5. Choose healthier options over high-calorie foods."],
      ["6. Follow this diet for at least four weeks before making changes."]
    ];

    autoTable(doc, {
      startY: currentY,
      head: [['General Guidelines']],
      body: guidelines,
      theme: 'grid',
      styles: {
        fontSize: TEXT_STYLES.SIZES.NORMAL,
        cellPadding: 3,
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: [255, 100, 20], // Orange
        textColor: [255, 255, 255], // White
        fontSize: TEXT_STYLES.SIZES.HEADER,
        fontStyle: 'bold',
        halign: 'left'
      }
    });

    let tableY = doc.lastAutoTable.finalY + 10;

    autoTable(doc, {
      startY: tableY,
      head: [['Points to be Noted']],
      body: points,
      theme: 'grid',
      styles: {
        fontSize: TEXT_STYLES.SIZES.NORMAL,
        cellPadding: 3,
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: [255, 100, 20], // Orange
        textColor: [255, 255, 255], // White
        fontSize: TEXT_STYLES.SIZES.HEADER,
        fontStyle: 'bold',
        halign: 'left'
      }
    });

    let lastY = doc.lastAutoTable.finalY + 10;
    if (lastY + imageReservedHeight < footerY) {
      this.addGuidelineImage(doc, lastY);
    } else {
      doc.addPage();
      this.addGuidelineImage(doc, PAGE_LAYOUT.MARGIN);
    }
  },

  addGuidelineImage: function (doc, yPosition) {
    doc.setPage(doc.getNumberOfPages());
    const base64Image = IMAGES.FOOTER;

    const imgWidth = PAGE_LAYOUT.CONTENT_WIDTH;
    const imgHeight = 50;
    doc.addImage(
      base64Image,
      'PNG',
      PAGE_LAYOUT.MARGIN,
      yPosition,
      imgWidth,
      imgHeight
    );
  }
};

